import { ISimpleTableCellRenderProps } from "@asup/simple-table";
import { eHierarchyLevel, eReleaseStatus } from "functions/api/enums";

/**
 * Table cell renderer that displays the release status for TLF items.
 *
 * @param props - The component props
 * @param props.rowData - Row data containing release status information
 */
export const RenderReleaseStatus = ({
  rowData,
}: ISimpleTableCellRenderProps): React.ReactElement => (
  <div className="overflow-hidden">
    <span>
      {
        (rowData.primaryHierarchyLevel === eHierarchyLevel.Report
          ? ""
          : rowData.releaseStatus === eReleaseStatus.ReleasePending
            ? eReleaseStatus.Draft
            : [eReleaseStatus.DecommissingPending, eReleaseStatus.RetirePending].includes(
                  rowData.releaseStatus as eReleaseStatus,
                )
              ? eReleaseStatus.Valid
              : rowData.releaseStatus) as string
      }
    </span>
  </div>
);

RenderReleaseStatus.displayName = "RenderReleaseStatus";
